import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { pagosAPI } from "../services/api";
import toast from "react-hot-toast";

export function useCartera(academiaId: string) {
  return useQuery({
    queryKey: ["cartera", academiaId],
    queryFn: () => pagosAPI.cartera(academiaId).then(r => r.data),
    enabled: !!academiaId,
  });
}
export function useHistorialPagos(jugadorId: string) {
  return useQuery({
    queryKey: ["pagos-historial", jugadorId],
    queryFn: () => pagosAPI.historial(jugadorId).then(r => r.data),
    enabled: !!jugadorId,
  });
}
export function useSubirComprobante() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, file }: { id: string; file: File }) => pagosAPI.subirComprobante(id, file),
    onSuccess: () => { toast.success("Comprobante subido"); qc.invalidateQueries({ queryKey: ["cartera"] }); },
    onError: () => toast.error("Error al subir comprobante"),
  });
}
export function useEnviarRecordatorios(academiaId: string) {
  return useMutation({
    mutationFn: () => pagosAPI.enviarRecordatorios(academiaId),
    onSuccess: (data) => toast.success(`Recordatorios enviados: ${data.data.enviados}`),
  });
}
